/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
      File Description            :  Company Advanced info Action Buttons
 --------------------------------------------------------------------------------- 
    Creation Details 
    Date Created				: 05/Aug/2020 
    Author						: Anand Kumar 
================================================================ 
*/

import React, { useEffect, useState } from "react";
import { saveCompanyAdvanced } from "../../../../../middleware/services/companyApi";
import { processingSubmit } from "../../../../../middleware/services/cmsApi";
import { Link, useHistory } from "react-router-dom";
import { getLoggedInUser, accessRightActionCheck } from "../../../../../utilities";
import { actionSuccess, actionError, hideLoader, showLoader } from "../../../../../middleware/actions/utilityAction";
import { setClickSaveSubmitState, setOverviewUpdateStatus } from "../../../../../middleware/actions/companyAction";
import { useDispatch, useSelector } from "react-redux";
import { showAlertBox } from "../../../../../middleware/actions/alertBoxAction";
import { COMMON_ACCESS_ACTION } from "../../../../../constants";
import PropTypes from "prop-types";

const ActionButtons = (props) => {
  const { accessRights: aR } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedInUser = getLoggedInUser();
  const companyId = props.companyId;
  const formik = props.formik;
  const cancelPath = props.back;
  const updateStatus = useSelector((state) => state.companyState.updateStatus);
  const clickStatus = useSelector((state) => state.companyState.clickStatus);
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props.hashArr)[props.selectedIndex];
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props.selectedIndex]);

  /* Common access */
  const accessActionSave = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SAVE);
  const accessActionSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SUBMIT);

  const sanitizeInput = (val) => {
    if (typeof val !== "string") return "";
    return val.replace(/<p>(&nbsp;|\s)*<\/p>/gi, "").trim();
  };

  const handleSave = (isSubmit) => {
    dispatch(showLoader());
    return new Promise((resolve, reject) => {
      formik.validateForm().then((res) => {
        if (Object.keys(res).length) {
          dispatch(hideLoader());
          const touched = {};
          Object.keys(res).map((field) => {
            touched[field] = true;
            return touched;
          });
          dispatch(actionError(res.companyAbout || res.companyWhatsUnique || res.companyBusinessModel || res.companyFuturePlans));

          formik.setFormikState({ ...formik, touched: touched, errors: res });
          reject("Validation failed");
        } else {
          const sanitizeKeys = ["companyAbout", "companyBusinessModel", "companyFuturePlans"];
          const formData = new FormData();

          Object.keys(formik.values).forEach((key) => {
            let value = formik.values[key];
            if (sanitizeKeys.includes(key) && typeof value === "string") {
              value = sanitizeInput(value);
            }
            formData.append(key, value || "");
          });
          saveCompanyAdvanced(companyId, formData)
            .then((res) => {
              dispatch(hideLoader());
              props.handleCommonSave(isSubmit);
              props?.getCompanyDetails();
              // dispatch(actionSuccess("Company advanced info saved successfully"));

              if (clickStatus) {
                dispatch(setClickSaveSubmitState());
              }
            })
            .catch((err) => {
              dispatch(hideLoader());

              dispatch(actionError(err?.data?.message || "Something went wrong"));
            });
          resolve("Success");
        }
      });
    });
  };

  const handleShowSubmitModal = () => {
    dispatch(
      showAlertBox({
        okCallback: async () => {
          dispatch(showLoader());
          handleSave(true).then(() => {
            processingSubmit(companyId, "advanced", {
              userId: loggedInUser._id,
            })
              .then((response) => {
                dispatch(actionSuccess(`Company successfully Saved & Submitted`));
                dispatch(setClickSaveSubmitState());
                dispatch(setOverviewUpdateStatus(false));
                dispatch(hideLoader());
              })
              .catch((err) => {
                console.log(err?.data?.message);
                dispatch(actionError(err?.data?.message || "Something went wrong"));
                dispatch(hideLoader());
              });
          });
        },
        cancelCallback: () => {
          dispatch(setClickSaveSubmitState(false));
          dispatch(setOverviewUpdateStatus(false));
        },
        okText: "Submit",
        cancelText: "Cancel",
        content: "Are you sure you want to submit ? ",
        title: "dialogAlertCss",
      })
    );
  };

  return (
    <div className="form-submit-box">
      <div style={{ display: "flex", gap: "1rem" }}>
        {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
          <button
            type="button"
            className="btn btn-outline-dark company-button"
            onClick={() => {
              (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                (props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex - 1));
            }}
          >
            Previous
          </button>
        ) : null}

        {props.selectedIndex > -1 ? (
          <button
            type="button"
            className="cy-adv-btn btn btn-outline-dark company-button"
            onClick={() => {
              props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex + 1);
            }}
          >
            Next
          </button>
        ) : null}
      </div>
      <div style={{ display: "flex", gap: "1rem" }}>
        <Link to={cancelPath}>
          <button
            type="button"
            className="btn btn-outline-dark company-button"
            onClick={() => {
              history.push(`${cancelPath}`);
            }}
          >
            Cancel
          </button>
        </Link>
        {accessActionSave ? (
          <button type="button" className="btn btn-primary company-button" onClick={() => handleSave(false)}>
            Save
          </button>
        ) : null}
        {accessActionSubmit ? (
          <>
            {cancelPath === "/processing/company" ? (
              <button
                type="button"
                className="btn btn-primary company-button"
                onClick={() => {
                  if (clickStatus) dispatch(setClickSaveSubmitState());
                  dispatch(setOverviewUpdateStatus(true));
                  dispatch(setClickSaveSubmitState(true));
                }}
              >
                Submit
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary company-button"
                onClick={() => {
                  handleShowSubmitModal();
                }}
              >
                {" "}
                Submit
              </button>
            )}{" "}
          </>
        ) : null}
      </div>
    </div>
  );
};
ActionButtons.propTypes = {
  accessRights: PropTypes.arrayOf(PropTypes.string),
  companyId: PropTypes.string,
  formik: PropTypes.object,
  selectedIndex: PropTypes.number,
  setCurrentTab: PropTypes.func,
  back: PropTypes.string,
  hashArr: PropTypes.array,
  handleCommonSave: PropTypes.func,
};

export default ActionButtons;
